import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// packs
import { faFacebookF, faInstagram, faMedium, faTwitter, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import {
  faCopy,
  faLongArrowDown,
  faPlus,
  faMinus,
  faFilter,
  faEnvelope,
  faPhone,
} from '@fortawesome/pro-regular-svg-icons';
import { faPlay, faHandPointer } from '@fortawesome/pro-solid-svg-icons';

// add packs to library
library.add(
  faFacebookF,
  faInstagram,
  faMedium,
  faTwitter,
  faWhatsapp,
  faCopy,
  faLongArrowDown,
  faPlus,
  faMinus,
  faFilter,
  faEnvelope,
  faPhone,
  faPlay,
  faHandPointer
);

// Register fontawesome as component
Vue.component('fa-icon', FontAwesomeIcon);
